import compose from 'recompose/compose';
import { withHandlers, withPropsOnChange } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import lifecycle from 'recompose/lifecycle';
import withFetchCampaign from '../hoc/withFetchCampaign';
import CampaignDraft from '../components/CampaignDraft';
import {
  setOwnerId,
  setOwnerType,
  resetCampaign,
  toggleSendSms,
  setCustomerGroup,
} from '../actions';
import { getShopBrandSmsOriginator, getShopBrandSmsOriginatorVerified } from '../../auth/selectors';
import { withBarberType } from '../../../modules/barber/barber-type/with-barber-type';

const CampaignDraftContainer = compose(
  withRouter,
  withBarberType,
  connect(
    (state, ownProps) => ({
      showPushPreview: state.engagement.campaign.sendPush || state.engagement.campaign.sendSms,
      campaignId: ownProps.params.campaignId,
      sendSms: state.engagement.campaign.sendSms,
      smsOriginatorConfigured: !!getShopBrandSmsOriginator(state) && getShopBrandSmsOriginatorVerified(state),
    }),
    dispatch => ({
      setOwnerId: bindActionCreators(setOwnerId, dispatch),
      setOwnerType: bindActionCreators(setOwnerType, dispatch),
      resetCampaign: bindActionCreators(resetCampaign, dispatch),
      toggleSendSms: bindActionCreators(toggleSendSms, dispatch),
      setCustomerGroup: bindActionCreators(setCustomerGroup, dispatch),
    }),
  ),
  withFetchCampaign,
  lifecycle({
    componentDidMount() {
      if (this.props.campaignId) {
        this.props.fetchCampaign();
      } else {
        this.props.resetCampaign();

        // default initial state for sendSms in redux store is true
        // but if sms originator is not configured text messages cannot be sent
        // thus we need to toggle it off
        // ideally this should be properly set in redux store defaults but obtaining sms originator
        // would be complicated to implement there
        const smsRequiresDisabling = !this.props.smsOriginatorConfigured && this.props.sendSms;
        if (smsRequiresDisabling) {
          this.props.toggleSendSms();
        }

        if (this.props.location.state && this.props.location.state.preSelectCustomerGroup) {
          this.props.setCustomerGroup({ name: this.props.location.state.preSelectCustomerGroup });
          this.props.router.replace({ pathname: this.props.location.pathname, state: null });
        }
      }

      this.props.setOwnerId(this.props.shopOrBarber.id);
      this.props.setOwnerType(this.props.shopOrBarber.type);
    },
  }),
  withPropsOnChange(['barberType', 'sendSms'], (props) => {
    if (props.barberType === 'studio' && props.sendSms) {
      props.toggleSendSms();
    }
  }),
)(CampaignDraft);

export default CampaignDraftContainer;
